import './instrument';
import 'core-js';
import React from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ScrollMemory from 'react-router-scroll-memory';
import App from './app/containers/App';
import ErrorPage from './app/containers/ErrorPage';
import { store } from './app/store/storeInstance';
import { ChampUserManager } from './app/auth/userManager';
import './sass/styles.scss';

import { AuthProvider } from 'react-oidc-context';
import ErrorState from './app/components/ErrorState';

const oidcConfig = {
  onSigninCallback: () => {
    const lsPostLoginUrl = localStorage.getItem('post_login_url');
    if (lsPostLoginUrl) {
      localStorage.removeItem('post_login_url');
      window.location = lsPostLoginUrl;
    } else {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  },
  userManager: ChampUserManager,
};

const container = document.getElementById('root');
const root = createRoot(container);
if (root) {
  root.render(
    <Sentry.ErrorBoundary fallback={<ErrorState fullHeight />}>
      <AuthProvider {...oidcConfig}>
        <Provider store={store}>
          <BrowserRouter>
            <ScrollMemory elementID="scroll-container"></ScrollMemory>
            <Switch>
              <Route exact path="/error" component={ErrorPage} />
              <Route path="/" component={App} />
            </Switch>
          </BrowserRouter>
        </Provider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  );
}

window.store = store;
window.axios = true;
